import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Card, CardBody, CardFooter, Col, Container, Form, FormGroup, Input, Label, Row, Table } from "reactstrap";
import { toast } from "react-toastify";

import { confirm } from "components/Confirmation";

import IconButton from "components/IconButton";
import CustomPagination from "components/CustomPagination";
import equipeService from "services/EquipeService";
import AppContext from "AppContext";
import { PapelEnum } from "services/PerfilService";
import comboService from "services/ComboService";
import { GFComboField } from "components/GeneralForm";

export default function Equipes() {
  const [pagina, setPagina] = useState(1)
  const [paginas, setPaginas] = useState(0)
  const [termo, setTermo] = useState(null)
  const [items, setItems] = useState([])
  const [idEmpresa, setIdEmpresa] = useState(null)
  const [empresas, setEmpresas] = useState([])
  const navigate = useNavigate()
  const { state } = useContext(AppContext)
  const idTipoPerfil = state?.user?.perfil?.idTipo || 0

  const podeGerenciar = (state?.user?.acoes || []).includes('equipe.gerenciar')

  const carregar = async () => {
    const res = await equipeService.get(termo, idEmpresa, pagina)
    if (res.success) {
      setItems(res.data.items)
      setPaginas(res.data.paginas)
    }
  }

  useEffect(() => {
    if (idTipoPerfil == PapelEnum.ADMIN) {
      comboService.empresa().then(res => {
        if (res.success) {
          setEmpresas(res.data)
        }
      })
    }
  }, [])

  useEffect(() => {
    carregar()
  }, [pagina])

  const handleDelete = (item) => {
    confirm({
      header: "Exclusão",
      text: "Tem certeza que gostaria de continuar?",
      icon: "bi-exclamation-triangle",
      onConfirm: async () => {
        try {
          const res = await equipeService.delete(item.id)
          if (res.success) {
            carregar()
            toast("Equipe excluída")
          } else {
            toast("Erro ao excluir a equipe")
          }
        } catch (ex) {
          if (!!ex.response.data?.message)
            toast(ex.response.data.message)
          else
            toast("Erro ao excluir a equipe")
        }
      }
    })
  }

  const handleSubmit = e => {
    e.preventDefault()
    setPagina(1)
    carregar()
  }

  return (
    <>
      <Container fluid>
        <div className="d-flex flex-row justify-content-between align-items-center">
          <h1 className="my-4">Equipes</h1>
          {podeGerenciar && (
            <Link className="btn btn-primary btn-icon" to="/admin/equipes/0">Incluir</Link>
          )}
        </div>

        <Card className="shadow mb-4">
          <CardBody>
            <Form onSubmit={handleSubmit}>
              <Row>
                {(idTipoPerfil == PapelEnum.ADMIN) && (
                  <GFComboField
                    colspan={3}
                    label="Empresa"
                    name="idEmpresa"
                    data={{ idEmpresa }}
                    onChange={(name, value) => setIdEmpresa(value)}
                    options={empresas}
                    optionValue="id"
                    optionLabel="razaoSocial"
                    showDefault
                    defaultValue="Todas"
                  />
                )}
                <Col>
                  <FormGroup>
                    <Label>Nome</Label>
                    <Input type="text" placeholder="Nome" value={termo || ''} onChange={e => setTermo(e.target.value)} />
                  </FormGroup>
                </Col>
                <Col className="d-flex align-items-end justify-content-end">
                  <FormGroup>
                    <Button type="submit" color="primary">Buscar</Button>
                  </FormGroup>
                </Col>
              </Row>
            </Form>
          </CardBody>
        </Card>

        <Card className="shadow">
          <Table className="align-items-center table-flush" responsive>
            <thead className="thead-light">
              <tr>
                {(idTipoPerfil == PapelEnum.ADMIN) && (
                  <th scope="col">Empresa</th>
                )}
                <th scope="col">Nome</th>
                <th scope="col">Encarregado</th>
                <th scope="col" style={{ width: 120 }}></th>
              </tr>
            </thead>
            <tbody>
              {items.length == 0 && (
                <tr>
                  <td colSpan={4} className="text-center">Nenhum registro</td>
                </tr>
              )}
              {items.map(el => (
                <tr key={el.id}>
                  {(idTipoPerfil == PapelEnum.ADMIN) && (
                    <td>{el.empresa}</td>
                  )}
                  <td>{el.nome}</td>
                  <td>{el.encarregado}</td>
                  <td className="d-flex flex-row gap-5px">
                    <IconButton alt="Editar" iconClass="bi-pencil-square" onClick={() => navigate("/admin/equipes/" + el.id)} />
                    {podeGerenciar && (
                      <IconButton alt="Excluir" iconClass="bi-trash" onClick={() => handleDelete(el)} />
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <CardFooter className="py-4">
            <CustomPagination pagina={pagina} paginas={paginas} onChange={setPagina} />
          </CardFooter>
        </Card>
      </Container>
    </>
  )
}